<template lang="pug">
.auto-form
  h3(v-if='title') {{title}}
  el-form.ui.form(:model='form', :rules='rules', ref='form')
    div(v-for='row in defines.form.layout', :class='fields_classes(row)')
      template(v-for='key in row')
        el-form-item.ui.field(:prop='key', :class='{required: prop(key).required, disabled: prop(key).$readonly(form) }')
          label
            | {{prop(key).label}}
            span(v-if='prop(key).note') {{prop(key).note}}

          template(v-if='prop(key).type === "select"')
            el-select(v-model='form[key]')
              el-option(v-for='item in prop(key).$select(form)', :key='item.key', :label='item.label', :value='item.key')

          template(v-else-if='prop(key).type === "number" || prop(key).type === "money"')
            el-input-number(v-model='form[key]', :min='prop(key).min', :max='prop(key).max', :controls='prop(key).controls || false')

          template(v-else-if='prop(key).type === "virtual"')
            el-input(:value='prop(key).$value(form)', @change='value => prop(key).setter(value,form)')

          template(v-else-if='prop(key).type === "check"')
            br
            el-checkbox(v-model='form[key]', :label='prop(key).label')

          template(v-else-if='prop(key).type === "time"')
            datepicker(v-model='form[key]', :label='prop(key).label')

          template(v-else-if='prop(key).type === "autocomplete"')
            el-autocomplete(
              v-model='form[key]',
              :fetch-suggestions='prop(key).suggestions(form)',
              @select='item => suggestions_handler(item, prop(key), key)')

          template(v-else)
            el-input(v-model='form[key]')

    .ui.field.actions(v-if='buttons')
      .ui.button.themed(@click='action_primary') {{text_primary}}
      .ui.button(v-if='buttonReset', @click='reset') 重置
      .ui.button(v-if='buttonCancel', @click='action_cancel') {{text_cancel}}
</template>

<script>
import Vue from 'vue'
import { MakeForm } from '../../utils'
import { Datepicker } from '../basic'
import MixAuto from './mixin'

const DEFAULT_FORM_CREATOR = {
  alias: 'submit',
  confirm: '确认操作?',
  goBack: false,
  payload() {
    return this.form
  },
  $onError(err) {
    console.error(err)
    if (this.defaultErrorHandler)
      this.$utils.DefaultErrorHandler.bind(this)(err)
    this.$emit('error', err)
  },
  $onSuccess(body) {
    this.$emit('submitted', body)
  },
}

export default {
  name: 'auto-form',
  props: {
    title: String,
    form: Object,
    formType: { type: String, default: 'create' }, // create, modify
    validate: { type: Boolean, default: true },
    buttons: { type: Boolean, default: true },
    buttonCancel: { type: Boolean, default: true },
    buttonReset: { type: Boolean, default: true },
    defaultErrorHandler: { type: Boolean, default: true },
    meta: { type: Object, default() { return {} } },
  },
  mixins: [MixAuto],
  components: { Datepicker },
  data() {
    return {
      form_original: {},
    }
  },
  created() {
    if (this.formType === 'create')
      this.reset() // To make fields in form object
  },
  mounted() {
    this.init()
  },
  computed: {
    keys() {
      const keys = []
      for (const fields of this.defines.form.layout) {
        for (const field of fields)
          keys.push(field)
      }
      return keys
    },
    text_primary() {
      return this.formType === 'create' ? '创建' : '保存'
    },
    text_cancel() {
      return '取消'
    },
    rules() {
      const rules = {}
      for (const key of this.keys) {
        if (this.prop(key).required)
          rules[key] = { required: true, message: `请输入${this.prop(key).label}` }
      }
      return rules
    },
  },
  methods: {
    init() {
      if (this.formType === 'modify')
        this.form_original = Object.assign(this.form_original, this.form)
      this.reset()
    },
    reset() {
      for (const key of this.keys)
        Vue.set(this.form, key, this.form_original[key] !== undefined ? this._form : this.prop(key).default)
      if (this.$refs.form)
        this.$refs.form.resetFields()
    },
    fields_classes(row) {
      if (!row || row.length <= 1)
        return ''
      const classes = ['', '', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'night', 'ten'][row.length]
      return `fields ${classes}`
    },
    suggestions_handler(item, prop, key) {
      if (prop.suggestions_handler)
        prop.suggestions_handler.call(this, item)
      else
        this.form[key] = item.value
    },
    form_validate() {
      return new Promise((resolve, reject) => {
        if (!this.validate)
          resolve(true)
        this.$refs.form.validate((valid) => {
          if (valid)
            resolve(valid)
          else
            reject(valid)
        })
      })
    },
    action_primary() {
      this.form_validate()
        .then(() => {
          if (this.formType === 'create')
            MakeForm(Object.assign({}, DEFAULT_FORM_CREATOR, this.defines.form.create)).bind(this)()
          else
            MakeForm(Object.assign({}, DEFAULT_FORM_CREATOR, this.defines.form.modify)).bind(this)()
        })
        .catch(err => {
          console.error(err)
        })
    },
    action_cancel() {
      this.$emit('cancel')
    },
  },
}
</script>



// WEBPACK FOOTER //
// AutoForm.vue?04ab8646